import { useCallback } from 'react';
import { useAuth } from '../contexts/auth';
import { setUserToLocalStorage } from '../utils/localStorage-utils';
import { axiosAdminSimple } from './useAxios';


const useRefreshToken = () => {

    const { user, setUser, setLoading } = useAuth()

    const refresh = useCallback(async (refreshToken) => {
        try {

            //console.log("Refresing...." + refreshToken)
            setLoading(true)
            const response = await axiosAdminSimple.post('/api/Authentication/RefreshToken',
                { refreshToken },
            );

            if (response.status === 200 || response.status === 201) {
                setUser(response.data.data)
                setUserToLocalStorage(response.data.data)
            }

            return response.data?.data?.accessToken;
        } catch (error) {
            // if (error.response.status === 400||error.response.status === 401) { BAD_REQUEST de statuscode 500 geldi, o yüzden hata gelirse user undefined
            //console.log("error.response.status", error.response.status)
            localStorage.removeItem(user)
            setUser(undefined)
            //}
        } finally {
            setLoading(false)
        }
    }, [user, setUser, setLoading])
    return refresh;
};


export default useRefreshToken;

